/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit State/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CalledDoctor from './CalledDoctor/index'
import DoctorArrived from './DoctorArrived/index'
import DoctorLeft from './DoctorLeft/index'
import No from './No/index'
import Ongoing from './Ongoing/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function State({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/State"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentBookingProviderCallValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'provider_call',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentBookingProviderCallValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ongoing'}>
<Ongoing
  viewPath={`${viewPath}/Ongoing`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CalledDoctor'}>
<CalledDoctor
  viewPath={`${viewPath}/CalledDoctor`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DoctorArrived'}>
<DoctorArrived
  viewPath={`${viewPath}/DoctorArrived`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DoctorLeft'}>
<DoctorLeft
  viewPath={`${viewPath}/DoctorLeft`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}